import React, { useEffect, useState } from 'react'
import CustomTextarea from '../../Common/CustomTextArea'
import api from '../../http'
import { toast } from 'react-toastify'
import { ErrorHandlingMessage } from '../../Utils/ErrorHandlingMessage'
import FullPageLoader from '../../Components/FullPageLoader/FullPageLoader'
import Validator, { ValidationTypes as V_Type, } from 'react-form-supervalidator';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import CustomInput from 'Common/CustomInput/CustomInput'
import CustomSelect from 'Common/CustomSelect/CustomSelect'
import { PAYMENT_METHODS } from 'Common/Constants'
import { SAVED_SUCCESSFULLY } from 'Common/ToastConstants'

const PaymentURL = process.env.REACT_APP_TC_PMS + "/api/Payment"
const AddPatientPaymentPopup = ({ onClose, modalRow }) => {
    const [paymentModel, setPaymentModel] = useState({
        practiceId: 0,
        addedBy: "",
        addedDate: "2023-06-26T10:59:20.212Z",
        updatedBy: "",
        updatedDate: "",
        inActive: false,
        inActiveReason: "",
        inActiveBy: "",
        inActiveDate: "",
        id: 0,
        paymentType: "EOB",
        receivedDate: "",
        depositDate: "",
        patientId: 0,
        payerId: "",
        payerName: "",
        paidAmount: 0,
        writeOffAmount: 0,
        paymentMethod: "",
        checkNumber: "",
        checkDate: "",
        ccTransactionID: "",
        ccTransactionDate: "",
        notes: "",
        isLocked: false,
        isPosted: false,
        postedBy: "",
        datePosted: "",
        isDuplicate: false,
        receiverId: 0,
        ediResponseDownloadedFileID: 0,
        status: "",
        payerAddress: "",
        payerCity: "",
        payerState: "st",
        payerZipCode: "",
        reF_2U_ID: "",
        payerContactPerson: "",
        payerContactNumber: "",
        markForAutoPosting: false,
        autoActionPerformed: false,
        paymentAttachment: null,
        visitPayments: null
    })
    const [loading, setLoading] = useState(false)
    const [validationModel, setValidationModel] = useState({
        paymentMethod: null,
        checkDate: null,
        // depositDate: null,
        // receivedDate: null,
        checkNumber: null,

    })
    useEffect(() => {

        if (modalRow) {
            setLoading(true)
            api.get(PaymentURL + `/FindPaymentMain/${modalRow.id}`).then(res => {

                setLoading(false)
                setPaymentModel({ ...modalRow, ...res.data.dataModel[0], })
            }).catch(err => {
                setLoading(false)
            })
        }

    }, [modalRow])
    const setValidation = () => {
        let validation_Obj = {
            ...validationModel,
            paymentMethod: Validator(paymentModel.paymentMethod, [V_Type.required], ['Payment Method is required'],),
            checkDate: Validator(paymentModel.checkDate, [V_Type.required], ['Check Date is required'],),
            // depositDate: Validator(paymentModel.depositDate, [V_Type.required], ['Deposit Date is required'],),
            // receivedDate: Validator(paymentModel.receivedDate, [V_Type.required], ['Received Date is required'],),
            checkNumber: Validator(paymentModel.checkNumber, [V_Type.required], ['Check No is required'],),

        }
        setValidationModel(validation_Obj)
        return Validator(validation_Obj, V_Type.NullCheck);
    }

    // const onhandleChange = (e) => {
    //     setPaymentModel((prev) => ({
    //         ...prev,
    //         [e.target.name]: e.target.value
    //     }))
    // }

    // const handleSelectedData = (selectedObj) => {



    //     if (selectedObj) {
    //         setPaymentModel((prev) => ({ ...prev, insurancePlanId: selectedObj.insurancePlanId, payerId: selectedObj.payerId, payerName: selectedObj.payerName }))
    //     } else {
    //         setPaymentModel((prev) => ({ ...prev, insurancePlanId: "", payerId: "", payerName: "", }))
    //     }
    // };

    const handleSavePayment = async () => {
        if (!setValidation()) {

            try {
                setLoading(true)
                await api.post(`${process.env.REACT_APP_TC_PMS}/api/Payment/SavePayment`, paymentModel)
                toast.success(SAVED_SUCCESSFULLY)
                setLoading(false)
                onClose(true)
            } catch (error) {
                setLoading(false)
                ErrorHandlingMessage(error)
            }
        }
    }
    const handlePaymentChange = e => {
        const { name, value } = e.target


        setPaymentModel({ ...paymentModel, [name]: value })

    }
    return (
        <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            {loading && <FullPageLoader />}
            <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                    <div className="relative max-w-6xl text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full">
                        <div className="bg-white ">
                            <div className="flex justify-between px-4 py-4 border-b-2">
                                <h2 className='text-xl font-semibold'>Patient Payment</h2>
                                <button onClick={onClose} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                                    <img src="/img/crossblack.svg" alt="cross" />
                                </button>
                            </div>
                            <div className="grid w-auto grid-cols-12 gap-4 p-3 bg-white border shadow-md ">


                                <div className="col-span-12 md:col-span-2">
                                    <label>Patient Name</label>
                                    <CustomInput disabled value={modalRow.paymentFrom
                                    } />
                                </div>
                                <div className="col-span-12 md:col-span-2">

                                    <CustomSelect disabled name={"paymentMethod"} value={paymentModel.paymentMethod} onChange={handlePaymentChange} required label="Payment Method" >
                                        <option value="Check">Check</option>
                                        <option value="Cash">Cash</option>
                                        <option value="Credit Card">Credit card</option>
                                    </CustomSelect>
                                    {/* {validationModel.paymentMethod} */}
                                </div>

                                {paymentModel.paymentMethod === PAYMENT_METHODS.CHECK && <div className="col-span-12 md:col-span-2">
                                    <CustomInput name={"checkDate"} value={paymentModel.checkDate} onChange={handlePaymentChange} label="Check Date" type="date" placeholder="Name" required={true} />
                                    {validationModel.checkDate}
                                </div>}

                                {paymentModel.paymentMethod !== PAYMENT_METHODS.CREDIT_CARD && <div className="col-span-12 md:col-span-2">
                                    <CustomInput disabled name={"receivedDate"} value={paymentModel.receivedDate?.split('T')[0]} onChange={handlePaymentChange} label="Received Date" type="date" placeholder="" />
                                    {validationModel.receivedDate}
                                </div>}



                                {paymentModel.paymentMethod === PAYMENT_METHODS.CHECK && <div className="col-span-12 md:col-span-2">
                                    <CustomInput name={"checkNumber"} value={paymentModel.checkNumber} onChange={handlePaymentChange} label="Check no" type="text" placeholder="" required={true} />
                                    {validationModel.checkNumber}
                                </div>}


                                <div className="col-span-12 md:col-span-2">
                                    <CustomInput name={"amount"} value={paymentModel.paidAmount} onChange={handlePaymentChange} label="Amount" type="text" placeholder="" />
                                </div>
                                <div className="col-span-12 md:col-span-2">
                                    <CustomInput name={"paymentAttachment"} value={paymentModel.paymentAttachment} onChange={handlePaymentChange} label="Attachment" type="file" placeholder="" />
                                </div> <div className="col-span-12 md:col-span-4">
                                    <CustomTextarea disabled rows={3} name={"comments"} value={paymentModel.comments} onChange={handlePaymentChange} label="Comments" ></CustomTextarea>
                                </div>



                            </div>

                            <div className="flex justify-end gap-2 px-4 py-4 border-t-2">
                                <CustomButtonNew label={"Cancel"} variant={"outline"} onClick={onClose} />
                                <CustomButtonNew label={"Save Payment"} onClick={handleSavePayment} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPatientPaymentPopup